export default {
  reservationTimeoutHeader: '19122018-152801-0021',
  reservationTimeoutMessageLine1: '19122018-152801-0022',
  reservationTimeoutMessageLine2: '19122018-152801-0023',
  reservationTimeoutMessageButton: '19122018-152801-0024'
};
